import React, { useState, useEffect } from 'react';

// material-ui icons
import PermMediaIcon from '@mui/icons-material/PermMedia';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

// IMPORT FUNCTIONS
import getUrl from  "../../../../utils/functions/getUrl";
import PostData from '../../../../services/PostData';

// IMPORT DATA FOR LOCAL USE
import imagesassoc from './imagesassocData';

// 
// manage albums catalogue
// 
// const Album = ( { handleOpenAlbum, album, albumIndex }) => {
const Album = ( 
  {
    album_id, 
    album_name, 
    handleOpenAlbum, 
    albumData, 
    albumIndex,
    setToggleDeleteAlbumModal,
    setDeleteAlbumDataModal
  }) => {

  const BASE_URL = getUrl();
  // console.log(`BASE_URL: ${BASE_URL}`);
  const [imgs] = useState(BASE_URL + '/uploaded/imgs/');
  const [mini] = useState(BASE_URL + '/uploaded/mini/');

  useEffect(()=>{
    console.log(`albumData:->`);
    console.log(albumData);

  },[]);

  // 
  // FUNCTIONS
  // 

  const handleDeleteAlbum = () => {
    console.log(`handleDeleteAlbum()`);

    setDeleteAlbumDataModal({
      album_id: album_id, 
      album_name: album_name
    });
    setToggleDeleteAlbumModal(true);
  }



  return (

    <div className='album' key={`${albumIndex}-albums`}>
      {
        // !albumData[0]
        // !albumData
        !albumData || Object.keys(albumData).length === 0
      ? 
        <div className='icon'><PermMediaIcon sx={{ fontSize: 180 }} />1111</div>
      :
        albumData[0] && <div className='icon'><img src={mini + albumData[0].img_name} alt={albumData[0].img_name} /></div>
      }
      <div className='textContainer'  onClick={()=>handleOpenAlbum(album_id, album_name)}  title={`open "${album_name}" album images`}>
        <div className='screen-one'></div>
        {albumData && <div className='images-count'>{albumData.length}</div>}
        <div className='screen-two'></div>
        <div className='text'>{album_name}</div>
      </div>
      <div className='iconsContainer' onClick={handleDeleteAlbum}  title='delete album' >
        <DeleteForeverIcon sx={{ fontSize: 24 }} />
      </div>
      
    </div>

  )
}

export default Album;